/** サーバー環境の種別に関する処理のクラス。 */
export default class Environment {
  /** 本番環境の場合に設定する環境変数の値。 */
  static readonly PRODUCTION = "master";
  /** ステージング環境の場合に設定する環境変数の値。 */
  static readonly STAGING = "stage";
  /** 開発環境の場合に設定する環境変数の値。 */
  static readonly DEV = "dev";
  /** 一般開放で空港グループのチェックができる環境 */
  static readonly CHECK_AIRPORT_GROUP = 'check_airport_group';
  /** 一般開放でバックエンドのdevを叩く環境 */
  static readonly BACKEND_DEV = 'backend_dev';
  /**
   * 本番環境であるかを判別する。
   * @param env 実行環境を識別するために設定している環境変数。
   * */
  static isProduction(env: string) {
    return env === Environment.PRODUCTION;
  }
  /**
   * ステージング環境であるかを判別する。
   * @param env 実行環境を識別するために設定している環境変数。
   * */
  static isStaging(env: string) {
    return env === Environment.STAGING;
  }
  /**
   * 開発環境であるかを判別する。
   * @param env 実行環境を識別するために設定している環境変数。
   */
  static isDev(env: string) {
    const devEnvList = [Environment.DEV, Environment.CHECK_AIRPORT_GROUP, Environment.BACKEND_DEV];
    return devEnvList.includes(env);
  }
  /**
   * 空港グループの確認環境かを判定
   * @param env 実行環境を識別するために設定している環境変数。
   */
  static isCheckAirportGroup(env: string) {
    return env === Environment.CHECK_AIRPORT_GROUP;
  }
  /**
   * バックエンドの環境について
   * @param env 実行環境を識別するために設定している環境変数。
   */
  static isBackendEnv() {
    return (process.env['REACT_APP_BACKEND_ENV'] || Environment.STAGING);
  }
  /**
   * ステージング環境か本番環境かを判別する。
   * @param env 実行環境を識別するために設定している環境変数。
   */
  static isUpperStaging(env: string) {
    return Environment.isProduction(env) || Environment.isStaging(env);
  }
  /**
   * strging型よりEnvironment型に変換する
   * @param env 現在の環境（）
   * @returns
   */
  static getEnvironmentType(env: string = (process.env['REACT_APP_STAGE_ENV'] || 'dev')) {
    if(Environment.isProduction(env)) {
      return Environment.PRODUCTION;
    }
    if(Environment.isStaging(env)) {
      return Environment.STAGING;
    }
    return Environment.DEV;
  }
  /**
   * UniversalMaaSModeかを判定する
   */
  static getIsUniversalMaaSMode(isLikeProdEnv?: any): boolean {
    // 環境変数よりUniversalMaaSModeかを判別する
    const isUniversalMaaSMode: string = (process.env['REACT_APP_IS_UNIVERSAL_MAAS_MODE'] || 'false')
    // TODO: 本番反映前に削除したほうが良いかも
    // POC環境でも疑似的に本番環境のように振る舞わせる
    if(process.env['REACT_APP_STAGE_ENV'] === 'dev' && isLikeProdEnv === 'true') {
      return false;
    }
    return isUniversalMaaSMode.toLowerCase() === 'true';
  }
}
